// extracted by mini-css-extract-plugin
module.exports = {"buttonMain":"AssetFile_buttonMain__1Gp0f","error":"AssetFile_error__z8ltV","fileWrap":"AssetFile_fileWrap__3I2v1","file":"AssetFile_file__1CHiG","empty":"AssetFile_empty__2aqws"};